export default __webpack_public_path__ + "static/media/comparisonIcon.c533d74c.PNG";